import React from 'react';
import { Layout, Row, Typography, Spin, Card } from 'antd';
import type { CardProps } from 'antd/lib/card';
import { createUseStyles } from 'react-jss';
import { useStoreState } from '../store';
import { headerBackground } from './styles';
import { ReactComponent as Logo } from '~/assets/logo-dark.svg';

const { Title } = Typography;
const { Content, Footer } = Layout;

const useStyles = createUseStyles({
  // minHeight (rather than a fixed height on Content) lets the footer sit at the bottom of the
  // viewport when the card is short, and get pushed down by taller content.
  layout: {
    minHeight: '100vh',
  },
  footer: {
    display: 'flex',
    justifyContent: 'center',
    background: headerBackground,
    borderTop: '1px solid #dddddd',
    padding: '12px 24px',
    textAlign: 'center',
  },
});

export interface UnauthenticatedLayoutProps extends CardProps {
  /** Rendered as a full-width banner pinned below the content. Omit for no footer. */
  footer?: React.ReactNode;
}

export const UnauthenticatedLayout = ({ children, footer, ...cardProps }: UnauthenticatedLayoutProps) => {
  const pageLoading = useStoreState((state) => state.loading.pageLoading);
  const classes = useStyles();

  return (
    <Layout className={classes.layout}>
      <Content>
        <Row justify="space-around" align="middle" style={{ margin: '50px 0 0 0' }}>
          <Typography>
            <Title level={2} style={{ margin: '0px 0 -10px -55px' }}>
              <Logo style={{ marginLeft: '40px', width: '168px', height: '56px', objectFit: 'contain' }}>
                <title>Shipium Logo</title>
              </Logo>
            </Title>
          </Typography>
        </Row>
        <Row justify="space-around" align="middle" style={{ margin: '10px' }}>
          <Spin spinning={pageLoading}>
            <Card style={{ width: 400 }} headStyle={{ textAlign: 'center' }} {...cardProps}>
              {children}
            </Card>
          </Spin>
        </Row>
        {/* The footer banner links the privacy policy itself, so it supersedes this row. */}
        {!footer && (
          <Row justify="space-around" align="middle" style={{ marginTop: 5 }}>
            <a href="https://www.shipium.com/privacy">Security and Privacy</a>
          </Row>
        )}
      </Content>
      {footer && <Footer className={classes.footer}>{footer}</Footer>}
    </Layout>
  );
};
